"use strict";

exports.__esModule = true;
exports.default = filter;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _each = _interopRequireDefault(require("./each.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return all the elements that pass a truth test.
function filter(obj, predicate, context) {
  var results = [];
  predicate = (0, _cb.default)(predicate, context);
  (0, _each.default)(obj, function (value, index, list) {
    if (predicate(value, index, list)) results.push(value);
  });
  return results;
}